enum SUGGESTION_TYPES {
  ACCEPTED_AND_EXECUTED = 'ACCEPTED_AND_EXECUTED',
  ACCEPTED_AND_EXECUTED_ON_WIP = 'ACCEPTED_AND_EXECUTED_ON_WIP',
  AWAITING_APPROVAL = 'AWAITING_APPROVAL',
  DELETED = 'DELETED',
  DELETED_WIP = 'DELETED_WIP',
  REJECTED = 'REJECTED',
  UNDER_CREATION = 'UNDER_CREATION',
}

enum SUGGESTION_CHANGE_TYPES {
  UNKNOWN = 'UNKNOWN',
  SHARE = 'SHARE', 
  DELETE_SCHEDULE = 'DELETE_SCHEDULE',
  ACTIVATE_SCHEDULE = 'ACTIVATE_SCHEDULE', 
  CHANGE_CHILDREN = 'CHANGE_CHILDREN',
  INACTIVATE_SCHEDULE = 'INACTIVATE_SCHEDULE',
  ADD_SCHEDULE_ENTRY = 'ADD_SCHEDULE_ENTRY',
  REMOVE_SCHEDULE_ENTRY = 'REMOVE_SCHEDULE_ENTRY',
  UPDATE_SCHEDULE_ENTRY = 'UPDATE_SCHEDULE_ENTRY',
}

enum SUGGESTION_REPLY_TYPES {
  UNKNOWN = 'UNKNOWN',
  ACCEPT = 'ACCEPT', 
  REJECT = 'REJECT',
}

enum HELP_TOPICS {
  LONGCLICK = 'LONGCLICK',
  CLICK_EDIT_DAYS = 'CLICK_EDIT_DAYS',
  WHERE_SENT_SUGGESTION = 'WHERE_SENT_SUGGESTION', 
  CALENDAR_MAIN = 'CALENDAR_MAIN',
  SELECT_MULTIPLE_DAYS = 'SELECT_MULTIPLE_DAYS',
  HOW_TO_MAKE_CALENDAR_CHANGES = 'HOW_TO_MAKE_CALENDAR_CHANGES',
  AI_EVENTS_ONBOARDING = 'AI_EVENTS_ONBOARDING',
  WRENCH_TOOLS = 'WRENCH_TOOLS',
}
export {SUGGESTION_TYPES, SUGGESTION_CHANGE_TYPES, SUGGESTION_REPLY_TYPES, HELP_TOPICS};


// WEBPACK FOOTER //
// ./src/constants/suggestionTypes.ts